const TradingCalculatorContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Instant Results</h4>
              </div>
              <p>
                Get accurate calculations in real-time so you can act fast when
                the markets move.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Multi-Market Coverage</h4>
              </div>
              <p>
                Whether you trade Forex, Stocks, or Crypto, the calculator
                supports all major instruments.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Risk Management Focused</h4>
              </div>
              <p>
                Understand your exposure before entering a trade to manage risk
                like a pro.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Beginner Friendly</h4>
              </div>
              <p>
                Simplified design and clear results make it easy for anyone to
                calculate with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCalculatorContentFour;
